// @flow
import type { Action } from './store.type';

export const GET_SEARCH_FEATURES_REQUEST = 'GET_SEARCH_FEATURES_REQUEST';
type GET_SEARCH_FEATURES_REQUEST_TYPE = 'GET_SEARCH_FEATURES_REQUEST';
export const GET_SEARCH_FEATURES_SUCCESS = 'GET_SEARCH_FEATURES_SUCCESS';
type GET_SEARCH_FEATURES_SUCCESS_TYPE = 'GET_SEARCH_FEATURES_SUCCESS';
export const GET_SEARCH_FEATURES_FAILURE = 'GET_SEARCH_FEATURES_FAILURE';
type GET_SEARCH_FEATURES_FAILURE_TYPE = 'GET_SEARCH_FEATURES_FAILURE';

export const UPDATE_AI_SEARCH_STATUS_REQUEST = 'UPDATE_AI_SEARCH_STATUS_REQUEST';
type UPDATE_AI_SEARCH_STATUS_REQUEST_TYPE = 'UPDATE_AI_SEARCH_STATUS_REQUEST';
export const UPDATE_AI_SEARCH_STATUS_SUCCESS = 'UPDATE_AI_SEARCH_STATUS_SUCCESS';
type UPDATE_AI_SEARCH_STATUS_SUCCESS_TYPE = 'UPDATE_AI_SEARCH_STATUS_SUCCESS';
export const UPDATE_AI_SEARCH_STATUS_FAILURE = 'UPDATE_AI_SEARCH_STATUS_FAILURE';
type UPDATE_AI_SEARCH_STATUS_FAILURE_TYPE = 'UPDATE_AI_SEARCH_STATUS_FAILURE';

export const GET_AI_SYNONYM_FEATURE_REQUEST = 'GET_AI_SYNONYM_FEATURE_REQUEST';
export const GET_AI_SYNONYM_FEATURE_SUCCESS = 'GET_AI_SYNONYM_FEATURE_SUCCESS';
export const GET_AI_SYNONYM_FEATURE_FAILURE = 'GET_AI_SYNONYM_FEATURE_FAILURE';

// Check live theme supported
type SearchControlSuccess = {};
type SearchControlFailure = {
  error: any
};
type GetSearchFeaturesRequestAction = Action<GET_SEARCH_FEATURES_REQUEST_TYPE, null>;
type GetSearchFeaturesSuccessAction = Action<
  GET_SEARCH_FEATURES_SUCCESS_TYPE,
  SearchControlSuccess
>;
type GetSearchFeaturesFailureAction = Action<
  GET_SEARCH_FEATURES_FAILURE_TYPE,
  SearchControlFailure
>;

type UpdateAISearchStatusRequestAction = Action<UPDATE_AI_SEARCH_STATUS_REQUEST_TYPE, null>;
type UpdateAISearchStatusSuccessAction = Action<
  UPDATE_AI_SEARCH_STATUS_SUCCESS_TYPE,
  SearchControlSuccess
>;
type UpdateAISearchStatusFailureAction = Action<
  UPDATE_AI_SEARCH_STATUS_FAILURE_TYPE,
  SearchControlFailure
>;
export type SearchControlAction =
  | GetSearchFeaturesRequestAction
  | GetSearchFeaturesSuccessAction
  | GetSearchFeaturesFailureAction
  | UpdateAISearchStatusRequestAction
  | UpdateAISearchStatusSuccessAction
  | UpdateAISearchStatusFailureAction;

export type SearchControlState = {
  synonym: 'on' | 'off',
  searchable: 'on' | 'off',
  merchandising: 'on' | 'off',
  aiSynonym: 'on' | 'off',
  featureGetting: boolean
};